module.exports = __webpack_public_path__ + "static/img/vote.bdb2a1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/vote.png
// module id = jm/f
// module chunks = 1